import React from "react";
import ReactDOM from "react-dom";
import App from "./app";
import store from "./store/store";
import { Provider } from "react-redux";
import "antd/dist/antd.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "rsuite/dist/rsuite.min.css";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";

import { ThemeProvider } from "styled-components";
import theme from "theme";
import {
  ApolloClient,
  InMemoryCache,
  ApolloLink,
  concat,
  ApolloProvider,
  createHttpLink,
} from "@apollo/client";

import "rsuite/dist/rsuite.min.css";
import environment from "environment";

const httpLink = createHttpLink({
  uri: environment.BACKEND_GRAPHQL_URL,
});

// const splitLink = split(
//   ({ query }) => {
//     const definition = getMainDefinition(query);
//     return (
//       definition.kind === "OperationDefinition" &&
//       definition.operation === "subscription"
//     );
//   },
//   wsLink,
//   httpLink
// );

const authMiddleware = new ApolloLink((operation, forward) => {
  // add the authorization to the headers
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      authorization: `Bearer ${localStorage.getItem("access_token")}` || null,
    },
  }));
  return forward(operation);
});

const client = new ApolloClient({
  link: concat(authMiddleware, httpLink),
  cache: new InMemoryCache(),
});

ReactDOM.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <App />
        </Provider>
      </ThemeProvider>
    </ApolloProvider>
  </React.StrictMode>,
  document.getElementById("root")
);
